
import React from 'react'
import useListadoVacaciones from '../hooks/useListadoVacaciones'
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { Alert, FloatingLabel, Form, Modal } from 'react-bootstrap';
import TooltipHover from '../components/TooltilHover';
import { InfoFillIcon } from '../assets/icons';
import { formatearFechaSpanish } from '../functions/formatearFecha';


export default function ListadoVacaciones() {

    const { listaVacaciones, getYear, borrar, cargando,
        mostrarAlerta, editar, handleClose, show, datosModal, setDatosModal,
        editarVacaciones
    } = useListadoVacaciones()
    const texto_vacaciones = 'Las vacaciones con fechas asignadas no pueden ser modificadas o eliminadas.'


    const RangoAsignado = ({ row }) => {
        if (row.inicio_vacaciones || row.fin_vacaciones) {

            // const inicio = formatearFecha(row.inicio_vacaciones)
            // const fin = formatearFecha(row.fin_vacaciones)
            // return `${inicio} - ${fin}`

            const inicio = (row.inicio_vacaciones) ? formatearFechaSpanish(row.inicio_vacaciones, false) : 'Sin asignar'
            const fin = (row.fin_vacaciones) ? formatearFechaSpanish(row.fin_vacaciones, false) : 'Sin asignar'
            return `${inicio} - ${fin}`

        } else {
            return 'No asignado'
        }
    }

    const CantidadVacaciones = () => {

        if (listaVacaciones.length > 0) {
            if (listaVacaciones.length === 1) {
                return <p className='lead'>1 registro</p>
            } else {
                return <p className='lead'>{`${listaVacaciones.length} registros`}</p>
            }
        } else {
            return ''
        }
    }

    const BtnsAcciones = ({ e }) => {

        if ( e.inicio_vacaciones && e.fin_vacaciones ) {
            return <TooltipHover
                tooltipText={texto_vacaciones}
                children={<Button variant="secondary-primary"> <InfoFillIcon /> </Button>}
            />
        } else {
            return (
                <>
                    <Button
                        variant="warning"
                        style={{
                            width: '100px',
                            height: 'min-content'
                        }}
                        onClick={() => editar(e.id)}
                    >
                        Editar
                    </Button>
                    <Button
                        variant="danger"
                        style={{
                            width: '100px',
                            height: 'min-content'
                        }}
                        onClick={() => borrar(e.id)}
                    >
                        Eliminar
                    </Button>
                </>
            )
        }

    }


    return (
        <>

            {cargando && <div className="d-flex justify-content-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p className='lead mx-2'>Cargando...</p>
            </div>}


            {mostrarAlerta && <Alert variant="info" className='m-3'>{texto_vacaciones}</Alert>}

            <CantidadVacaciones />

            {
                listaVacaciones.length > 0 ? (
                    <div className='table-responsive mt-4'>
                        <Table bordered hover>
                            <thead>
                                <tr>
                                    <th>Mes solicitado</th>
                                    <th>Rango de vacaciones asignadas</th>
                                    <th>Día en que se realizó la solicitud</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listaVacaciones.map((e, i) => (
                                    <tr key={i}>
                                        <td>
                                            {e.fecha_propuesta} {getYear(e.fecha_solicitud)}
                                        </td>
                                        <td>
                                            <RangoAsignado row={e} />
                                        </td>
                                        <td>
                                            {formatearFechaSpanish(e.fecha_solicitud)}
                                        </td>
                                        <td>
                                            <div className='d-flex gap-2 justify-content-center'>
                                                <BtnsAcciones e={e} />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <Alert variant='info'>
                        <p>Aún no hay registros de vacaciones.</p>
                        <p>Puedes agregar uno nuevo en la sección "Solicitar vacaciones".</p>
                    </Alert>
                )
            }
            {/* <Toaster/> */}



            {/* modal */}
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                {/* header */}
                <Modal.Header
                    closeButton
                    style={{
                        borderBottom: 'none',
                    }}
                >
                    <Modal.Title>Modifica la fecha de vacaciones</Modal.Title>
                </Modal.Header>


                {/* body */}
                <Modal.Body>

                    <form onSubmit={e => e.preventDefault()}>

                        <div className='row'>
                            <div className='col'>
                                <FloatingLabel controlId="floatingSelect" label="Mes de vacaciones">
                                    <Form.Select aria-label="Mes de vacaciones" value={datosModal.fecha_propuesta} onChange={e => setDatosModal({ ...datosModal, fecha_propuesta: e.target.value })}>
                                        <option value={'0'}>Selecciona una opción</option>
                                        <option value="Julio">Julio</option>
                                        <option value="Agosto">Agosto</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </div>
                        </div>

                    </form>

                </Modal.Body>

                {/* footer */}
                <Modal.Footer
                    style={{
                        borderTop: 'none',
                    }}
                >
                    <Button variant="secondary" onClick={handleClose}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={editarVacaciones}>
                        Guardar cambios
                    </Button>
                </Modal.Footer>

            </Modal>

        </>
    )
}
